/* eslint-disable @tanstack/query/exhaustive-deps -- they are there */
import { useQuery } from "@tanstack/react-query";

import { useCurrentTill } from "~/api/tills/hooks/use-till-current";

import { sessionsKeys } from "../keys";
import { getSession, type GetSessionArgs } from "../requests";
import { isSessionStartedToday } from "../is-session-started-today";

export function useSession({
  tillId,
  sessionId,
  ...args
}: Omit<GetSessionArgs, "tillId" | "sessionId"> & {
  tillId: string | undefined;
  sessionId: string | undefined;
}) {
  return useQuery({
    queryKey: sessionsKeys.detail({
      sessionId: sessionId ?? "unknown",
      tillId: tillId ?? "unknown"
    }),
    queryFn: () =>
      getSession({
        ...args,
        tillId: tillId ?? "unknown",
        sessionId: sessionId ?? "unknown"
      }),
    enabled: Boolean(tillId && sessionId)
  });
}

export function useCurrentSession() {
  const { data: till } = useCurrentTill();

  return useQuery({
    queryKey: sessionsKeys.detail({
      sessionId: till?.sessionId ?? "unknown",
      tillId: till?.id ?? "unknown"
    }),
    queryFn: () =>
      getSession({
        sessionId: till?.sessionId ?? "unknown",
        tillId: till?.id ?? "unknown"
      }),
    select: (data) => ({
      ...data,
      isValid: isSessionStartedToday(data.startedAt, till?.timezone)
    }),
    enabled: Boolean(till?.sessionId),
    refetchInterval: 1000 * 60 * 5, // 5 minutes
    refetchIntervalInBackground: true
  });
}
